import { render, staticRenderFns } from "./index.template.html?vue&type=template&id=7f6b9d50&scoped=true&external"
import script from "./index.options.js?vue&type=script&lang=js&external"
export * from "./index.options.js?vue&type=script&lang=js&external"
import style0 from "./index.vue?vue&type=style&index=0&id=7f6b9d50&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f6b9d50",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7f6b9d50')) {
      api.createRecord('7f6b9d50', component.options)
    } else {
      api.reload('7f6b9d50', component.options)
    }
    module.hot.accept("./index.template.html?vue&type=template&id=7f6b9d50&scoped=true&external", function () {
      api.rerender('7f6b9d50', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/orderCenter/serviceOroviderOrder/index.vue"
export default component.exports